import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    lineHeight: 1,
    fontSize: '24px'
  },

  currency: {
    marginRight: '0.1em',
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  dollarSign: {
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  dollarSignSuper: {
    position: 'relative',
    top: '-0.1em',
    fontSize: '60%',
    marginRight: '0.1em',
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  dollars: {
    fontWeight: 'bold',
    lineHeight: 1,
    color: theme.palette.blue[800]
  },

  cents: {
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  centsSuper: {
    position: 'relative',
    top: '-0.1em',
    fontSize: '60%',
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  separator: {
    color: theme.palette.blue[800],
    fontWeight: 'bold'
  },

  noLeftMargin: {
    marginLeft: 0
  }
}

export default styles
